import forOwn from 'lodash-es/forOwn';
import isEmpty from 'lodash-es/isEmpty';
import uniq from 'lodash-es/uniq';

import type { AlgoliaProduct, JaneSearchState } from '@jane/search/types';
import { getPriceLabel, getWeightLabel } from '@jane/search/util';

export const buildFiltersList = (
  filterOptions: JaneSearchState<AlgoliaProduct>
) => {
  let filtersList: string[] = [];
  let filterSections: string[] = [];

  //Add bucket filters (star rating, price)
  forOwn(
    filterOptions?.bucketFilters,
    (filters: string[], filterType: string) => {
      if (filters.length > 0) {
        if (filterType === 'aggregate_rating') {
          filters.forEach((rating) => {
            filtersList = [...filtersList, `${rating.split(':')[0]}+ stars`];
          });
          filterSections = [...filterSections, 'ratings'];
        } else if (filterType === 'bucket_price') {
          filters.forEach((price) => {
            filtersList = [...filtersList, getPriceLabel(price)];
          });
          filterSections = [...filterSections, 'price'];
        }
      }
    }
  );

  //Add filters (categories/subcategories, brands, lineage, weights, feelings)
  forOwn(filterOptions?.filters, (filters: string[], filterType: string) => {
    if (filters.length > 0) {
      if (filterType === 'root_types') {
        filters.forEach((category) => {
          if (category.includes(':')) {
            filtersList = [...filtersList, category.split(':')[1]];
            filterSections = [...filterSections, 'subcategory'];
          } else {
            filtersList = [...filtersList, category];
            filterSections = [...filterSections, 'category'];
          }
        });
      } else if (filterType === 'available_weights') {
        filters.forEach((weight) => {
          filtersList = [...filtersList, getWeightLabel(weight)];
        });
        filterSections = [...filterSections, 'weights'];
      } else if (filterType === 'category') {
        filtersList = [...filtersList, ...filters];
        filterSections = [...filterSections, 'lineage'];
      } else {
        filtersList = [...filtersList, ...filters];
        filterSections = [...filterSections, filterType];
      }
    }
  });

  //Add range filters (thc %, cbd %)
  forOwn(filterOptions?.rangeFilters, (filters: object, filterType: string) => {
    if (!isEmpty(filters)) {
      if (filterType === 'percent_thc') {
        filtersList = [...filtersList, 'thc %'];
        filterSections = [...filterSections, 'thc potency'];
      } else if (filterType === 'percent_cbd' && !isEmpty(filters)) {
        filtersList = [...filtersList, 'cbd %'];
        filterSections = [...filterSections, 'cbd potency'];
      }
    }
  });

  return {
    filtersList,
    filterSections: uniq(filterSections),
  };
};
